import {
  OTPErrorDTO,
  RequestResetPasswordCheckOTPDTO,
  RequestResetPasswordNewPasswordDTO,
  requestResetPasswordOTPDTO,
  SuccessCheckOTPToState,
  SuccessOTPToState,
} from "@core/models/forgot-password.interface";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const forgotPasswordActions = createActionGroup({
  source: "Forgot Password",
  events: {
    // ACTIONS for request OTP
    "Request Reset Password OTP": props<requestResetPasswordOTPDTO>(),
    "Request Reset Password OTP Success": props<SuccessOTPToState>(),
    "Request Reset Password OTP Failed": props<OTPErrorDTO>(),
    // ACTIONS for request check OTP valid
    "Request Reset Password Check OTP":
      props<RequestResetPasswordCheckOTPDTO>(),
    "Request Reset Password Check OTP Success": props<SuccessCheckOTPToState>(),
    "Request Reset Password Check OTP Failed": props<OTPErrorDTO>(),
    // ACTIONS for send new password
    "Request Send New Password": props<RequestResetPasswordNewPasswordDTO>(),
    "Request Send New Password Success": emptyProps(),
    "Request Send New Password Failed": props<OTPErrorDTO>(),
    // ACTIONS to reset state to individual steps
    "Reset State To Step One": emptyProps(),
    "Reset State To Step Two": emptyProps(),
  },
});
